module.exports = __webpack_public_path__ + "img/icon-instagram.992d1c1d.svg";